<template>
  <form class="form-horizontal">
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="email-input">Email</label>
      <div class="col-md-9">
        <input type="email" id="email-input" name="email" class="form-control"
               placeholder="Enter Email" v-model="localFormData.email">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="firstname-input">First name</label>
      <div class="col-md-9">
        <input type="text" id="firstname-input" name="firstname" class="form-control"
               placeholder="Enter first name" v-model="localFormData.firstname">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="lastname-input">Last name</label>
      <div class="col-md-9">
        <input type="text" id="lastname-input" name="lastname" class="form-control"
               placeholder="Enter last name" v-model="localFormData.lastname">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="role-select">Role</label>
      <div class="col-md-9">
        <select id="role-select" name="role" class="form-control" v-model="localFormData.role_id">
          <option v-for="role in roles" :value="role.id" :key="role.slug">
            {{ role.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row" v-if="fields[0] && localFormData.role_id === 3">
      <label class="col-md-3 col-form-label" for="role-select">Clients</label>
      <div class="col-md-9">
        <el-option-group label="Press Tab/Escape to exit">
          <el-select
              v-model="localFormData.clients"
              size="small"
              class="w-100"
              placeholder="Select clients" filterable multiple collapse-tags
          >
            <el-option
                v-for="value in getClients(fields[0].data)"
                :key="value.value" :label="value.value" :value="value.value">
              <span style="float: left">{{value.value}}</span>
            </el-option>
          </el-select>
        </el-option-group>
      </div>
    </div>
  </form>
</template>

<script>
import _ from 'lodash'
import userGetters from '../../store/modules/users/getterTypes'
import { mapActions, mapGetters } from 'vuex'
import studiesGetters from '../../store/modules/studies/getterTypes'
import studiesActions from '../../store/modules/studies/actionTypes'

export default {
  name: 'AddUser',
  emits: ['update:formData'],
  props: {
    formData: Object
  },
  data () {
    return {
      localFormData: { ...this.formData }
    }
  },
  computed: {
    ...mapGetters({
      fields: studiesGetters.GET_FIELDS,
      roles: userGetters.GET_ROLES
    })
  },
  methods: {
    ...mapActions({
      getFields: studiesActions.FETCH_FIELDS
    }),
    getClients (data) {
      return data.find(el => el.field === 'client').options
    }
  },
  async beforeMount () {
    if (!this.fields.length) {
      await this.getFields()
    }
  },
  watch: {
    // Compare by value: both branches assign a freshly spread object, so an
    // identity check can never be false and the pair never settles - each pass
    // allocates more objects and re-triggers the other watcher.
    formData: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localFormData)) {
          this.localFormData = _.cloneDeep(value)
        }
      }
    },
    localFormData: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.formData)) {
          this.$emit('update:formData', _.cloneDeep(value))
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
